var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_436_179",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "#D9D9D9"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask0_436_179)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z",
      "fill": "white"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }